/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { GET, PUT } from '/client/src/api';

type PropsType = {
    users: [],
    eventId: string | number,
    handleCheckInUpdate: () => void
};

const tabs = [
    {
        value: 'first_name',
        label: 'name'
    },
    {
        value: 'email_address',
        label: 'email'
    },
    {
        value: 'check_code',
        label: 'ticket code'
    }
];

const CheckInEventUsers = ({ eventId, handleCheckInUpdate }: PropsType): React.Element<'div'> => {
    const getGroupedUsers = (users: []): [] => {
        const sorted = _.sortBy(users, sortType);
        const labeled = _.map(sorted, (el: {}): {} => ({ ...el, label: el[sortType][0]?.toUpperCase() }));

        return _.groupBy(labeled, 'label');
    };


    const [isPending, setPending] = React.useState(false);
    const [sortType, setsortType] = React.useState('first_name');
    const [searchInput, setSearchInput] = React.useState('');
    const [users, setUsers] = React.useState([]);

    const fetchUsers = async () => {
        try {
            setPending(true);
            const { result } = await GET(`/api/v1/1/events/${eventId}/attendees/search?max_result_count=120&skip_count=0&has_voided=false&search_text=${searchInput}&search_type=all`);

            const grouped = getGroupedUsers(result.items);

            setUsers(grouped);
            setPending(false);
        } catch (e) {
            setPending(false);
            console.log(e);
        }
    };

    const toggleCheckIn = async (barcode: number | string, labelKey: string, userId: string | number, hasChecked: boolean) => {
        try {
            setPending(true);
            await PUT(`/api/v1/1/events/${eventId}/attendees/${barcode}/${ hasChecked ? 'cancel_checkin' : 'checkin'  }`);
            const _users = { ...users };
            const updatedUsers = _users[labelKey].map((user: {}): any => {
                if (user.id === userId) {
                    return {
                        ...user,
                        has_checked: !hasChecked
                    };
                }
                return user;
            });

            _users[labelKey] = updatedUsers;
            setUsers(_users);
            handleCheckInUpdate();
            setPending(false);
        } catch (e) {
            console.log(e);
            setPending(false);
        }
    };

    React.useEffect(() => {
        fetchUsers();
    }, [eventId, searchInput, sortType]);

    const msg = (): any => {
        if (_.size(users)) return;
        if (!isPending) return <div className='user-list-empty-msg'>Not found</div>;
    };

    return (
        <section>
            {isPending && <div className='csspinner' />}
            <div className='checkin-users-filter-container'>
                <div className='search-box'>
                    <input type='text' placeholder='search' onChange={(e: {}): void => setSearchInput(e.target.value)} />
                    <span className='icon icon-search' />
                </div>
                    <ul className='checkin-filter-items'>
                        {_.map(tabs, (tabI: {}, tabK: number): React.Element<'li'> => (
                            <li
                              key={`check-in-users-tab-${tabK}`}
                              className={sortType === tabI.value ? 'active' : ''}
                              onClick={(): void => setsortType(tabI.value)}
                            >
                                {tabI.label}
                            </li>
                        ))}
                    </ul>
            </div>
            <ul className='user-list__grouped'>
                {
                    Object.entries(users).map(([label, users]): any => (
                        <>
                            <div
                              className='user-list-item_group-header'
                              key={label}
                            >{label}</div>
                            <ul>
                                {users.map((user: {}): any => (
                                    <li key={user.name} onClick={(): void => toggleCheckIn(user.barcode, label, user.id, user.has_checked)}>
                                        <div className='user-list-item'>
                                            <span className='user-list-item_name'>{`${user.first_name} ${user.last_name}`}</span>
                                            <div className='user-list-item_info'>
                                            <span style={{ marginRight: '6px' }}>{user.check_code}</span>
                                            <span>{user.email_address}</span>
                                            </div>
                                            {
                                                user.has_checked &&
                                                    <span className='checkmark' />
                                            }
                                        </div>

                                    </li>
                                ))}
                            </ul>
                        </>
                    ))
                }
            </ul>
            { msg()}
        </section>
    );
};

export default CheckInEventUsers;